if (!window.Eurus.loadedScript.includes("rr-footer-newsletter-form.js")) {
  window.Eurus.loadedScript.push("rr-footer-newsletter-form.js");
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xFooterNewsletterForm", () => ({
        isInvalid: false,
        init() {
            const newsletterFormEl = document.getElementById("ContactFooter");
            this.originalSubmit = newsletterFormEl.submit;
            newsletterFormEl.submit = () => {
                this.handleSubmit(newsletterFormEl);
            }
        },     
        handleSubmit(formEl) {
            const formData = new FormData(formEl);
            if(this.validateForm(formData)) {
                this.originalSubmit.call(formEl);
                return;
            }
            this.isInvalid = true;
        },
        validateForm(formData) {
            const email = formData.get("contact[email]");
            return this.validateEmail(email);
        },
        validateEmail(email) {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        }
      }));
    });
  });
}